import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import {
  FaMapMarkerAlt,
  FaPhone,
  FaStar,
  FaWifi,
  FaParking,
  FaUtensils,
  FaFilter,
} from "react-icons/fa";
import ardiImage from '../../../Assets/Image/hotels/ardi.jpg';
import ardiImage2 from '../../../Assets/Image/hotels/ardi.jpg';
import ardiImage3 from '../../../Assets/Image/hotels/ardi.jpg';
import ardiImage4 from '../../../Assets/Image/hotels/ardi.jpg';
import ardiImage5 from '../../../Assets/Image/hotels/ardi.jpg';
import ardiImage6 from '../../../Assets/Image/hotels/ardi.jpg';
import ardiImage7 from '../../../Assets/Image/hotels/ardi.jpg';
import ardiImage8 from '../../../Assets/Image/hotels/ardi.jpg';
const PageWrapper = styled(motion.div)`
  background: linear-gradient(135deg, #69bdd9 0%, #0d3a49 100%);
  min-height: 100vh;
  padding: 60px 20px;
  position: relative;
  overflow: hidden;
  color: #fff;
  font-family: 'Arial', sans-serif;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: radial-gradient(circle at 100% 0%, rgba(255, 255, 255, 0.05) 0%, transparent 50%);
    pointer-events: none;
  }
`;

const Header = styled(motion.div)`
  text-align: center;
  margin-bottom: 40px;

  h2 {
    font-weight: bold;
    font-size: 3rem;
    background:  #fff
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    margin-bottom: 15px;
  }

  p {
    font-size: 1.2rem;
    opacity: 0.9;
  }
`;

const SearchBar = styled(motion.div)`
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  padding: 20px;
  border-radius: 25px;
  margin-bottom: 40px;
  display: flex;
  flex-direction: column;

  input {
    width: 100%;
    padding: 15px;
    border: none;
    border-radius: 20px;
    background: rgba(255, 255, 255, 0.8);
    font-size: 1rem;

    &:focus {
      outline: none;
      box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.4);
    }
  }

  .filters {
    display: flex;
    gap: 10px;
    margin-top: 15px;

    button {
      background: #1d72b8;
      border: none;
      padding: 10px 15px;
      border-radius: 20px;
      color: white;
      display: flex;
      align-items: center;
      gap: 5px;
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover {
        background: #0d47a1;
        transform: translateY(-2px);
      }

      &.active {
        background: #ffffff;
        color: #1a237e;
      }
    }
  }
`;

const HotelCard = styled(motion.div)`
  background: rgba(255, 255, 255, 0.95);
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.05);
  }
`;

const HotelImage = styled(Card.Img)`
  height: 200px;
  object-fit: cover;
  transition: filter 0.3s ease;

  ${HotelCard}:hover & {
    filter: brightness(0.8);
  }
`;

const HotelDescription = styled(Card.Text)`
  text-align: justify;
  font-size: 0.95rem;
  color: #555;
  margin-bottom: 15px;
`;

const Amenities = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
  color: #1a237e;
`;

const Location = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  color: #666;
  font-size: 0.9rem;
  margin-bottom: 10px;
`;

const Rating = styled.div`
  color: #ffc107;
  display: flex;
  gap: 2px;
  margin-bottom: 10px;
`;

const ViewButton = styled(Button)`
  background-color: #1d72b8;
  border: none;
  padding: 10px 20px;
  transition: background-color 0.3s ease, transform 0.2s;

  &:hover {
    background-color: #0d47a1;
    transform: translateY(-2px);
  }
`;

const HotelsInSemera = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [activeFilter, setActiveFilter] = useState("all");
  const controls = useAnimation();
  const [ref, inView] = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });

  useEffect(() => {
    if (inView) {
      controls.start("visible");
    }
  }, [controls, inView]);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const hotels = [
    {
      id: 1,
      name: "Semera Grand Hotel",
      image: ardiImage,
      description:
        "Luxury hotel featuring modern amenities and exceptional service with panoramic views of the Afar region.",
      location: "Downtown Semera",
      rating: 4.5,
      phone: "+251-911-123456",
      amenities: ["wifi", "parking", "restaurant"],
    },
    {
      id: 2,
      name: "Afar Paradise Resort",
      image: ardiImage2,
      description:
        "Peaceful retreat with luxurious rooms, swimming pool, and authentic local cuisine.",
      location: "Eastern Semera",
      rating: 4.3,
      phone: "+251-911-234567",
      amenities: ["wifi", "parking", "restaurant"],
    },
    {
      id: 3,
      name: "Semera Oasis Hotel",
      image:ardiImage3,
      description:
        "Traditional hospitality with beautiful gardens and comfortable accommodations.",
      location: "Central Semera",
      rating: 4.2,
      phone: "+251-911-345678",
      amenities: ["wifi", "restaurant"],
    },
    {
      id: 4,
      name: "Desert Rose Inn",
      image: ardiImage4,
      description:
        "Boutique hotel offering unique blend of modern comfort and local culture.",
      location: "North Semera",
      rating: 4.0,
      phone: "+251-911-456789",
      amenities: ["wifi", "parking"],
    },
    {
      id: 5,
      name: "Semera City Hotel",
      image: ardiImage5,
      description:
        "Contemporary hotel with business facilities and premium services.",
      location: "Business District",
      rating: 4.4,
      phone: "+251-911-567890",
      amenities: ["wifi", "parking", "restaurant"],
    },
    {
      id: 6,
      name: "Danakil Lodge",
      image: ardiImage6,
      description:
        "Eco-friendly lodge with traditional architecture and modern amenities.",
      location: "South Semera",
      rating: 4.1,
      phone: "+251-911-678901",
      amenities: ["wifi", "restaurant"],
    },
    {
      id: 7,
      name: "Afar Cultural Hotel",
      image: ardiImage7,
      description:
        "Experience authentic Afar culture with comfortable accommodations.",
      location: "West Semera",
      rating: 4.0,
      phone: "+251-911-789012",
      amenities: ["wifi", "restaurant"],
    },
    {
      id: 8,
      name: "Semera Sun Hotel",
      image: ardiImage8,
      description: "Modern hotel with rooftop restaurant and city views.",
      location: "Central Business District",
      rating: 4.3,
      phone: "+251-911-890123",
      amenities: ["wifi", "parking", "restaurant"],
    },
    {
      id: 9,
      name: "Gateway Hotel Semera",
      image: ardiImage,
      description:
        "Convenient location with comfortable rooms and friendly service.",
      location: "Near Airport",
      rating: 4.2,
      phone: "+251-911-901234",
      amenities: ["wifi", "parking", "restaurant"],
    },
  ];

  const cardVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut",
      },
    },
  };

  const filteredHotels = hotels.filter((hotel) => {
    const matchesSearch =
      hotel.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      hotel.location.toLowerCase().includes(searchTerm.toLowerCase());

    if (activeFilter === "all") return matchesSearch;
    if (activeFilter === "wifi")
      return matchesSearch && hotel.amenities.includes("wifi");
    if (activeFilter === "parking")
      return matchesSearch && hotel.amenities.includes("parking");
    if (activeFilter === "restaurant")
      return matchesSearch && hotel.amenities.includes("restaurant");
    return matchesSearch;
  });

  const renderRating = (rating) => {
    return [...Array(5)].map((_, index) => (
      <FaStar
        key={index}
        color={index < Math.floor(rating) ? "#ffc107" : "#e4e5e9"}
      />
    ));
  };

  const renderAmenities = (amenities) => {
    return (
      <Amenities>
        {amenities.includes("wifi") && <FaWifi title="Free WiFi" />}
        {amenities.includes("parking") && <FaParking title="Parking Available" />}
        {amenities.includes("restaurant") && <FaUtensils title="Restaurant" />}
      </Amenities>
    );
  };

  return (
    <PageWrapper ref={ref} initial="hidden" animate={controls} variants={containerVariants}>
      <Container>
        <Header
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h2>Hotels in Semera, Afar</h2>
          <p>Discover comfortable stays in the heart of Afar region</p>
        </Header>

        <SearchBar
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
        >
          <input
            type="text"
            placeholder="Search hotels by name or location..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <div className="filters">
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className={activeFilter === "all" ? "active" : ""}
              onClick={() => setActiveFilter("all")}
            >
              <FaFilter /> All
            </motion.button>
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className={activeFilter === "wifi" ? "active" : ""}
              onClick={() => setActiveFilter("wifi")}
            >
              <FaWifi /> WiFi
            </motion.button>
            {/* Add more filter buttons as needed */}
          </div>
        </SearchBar>

        <Row className="g-4">
          {filteredHotels.map((hotel) => (
            <Col lg={4} md={6} key={hotel.id}>
              <HotelCard
                variants={cardVariants}
                whileHover={{ y: -5 }}
              >
                <HotelImage variant="top" src={hotel.image} alt={hotel.name} />
                <Card.Body>
                  <Card.Title className="fw-bold mb-2">{hotel.name}</Card.Title>
                  <Location>
                    <FaMapMarkerAlt /> {hotel.location}
                  </Location>
                  <Rating>{renderRating(hotel.rating)}</Rating>
                  <HotelDescription>{hotel.description}</HotelDescription>
                  {renderAmenities(hotel.amenities)}
                  <Location>
                    <FaPhone /> {hotel.phone}
                  </Location>
                  <ViewButton className="w-100">Book Now</ViewButton>
                </Card.Body>
              </HotelCard>
            </Col>
          ))}
        </Row>
      </Container>
    </PageWrapper>
  );
};

export default HotelsInSemera;